if ( $('.honeycomb').length > 0 ) {

	$('.hex').on('click',function(e) {

		let title = $(this).data('title');
		let text = $(this).data('text');
		$('#hex-text').html('<strong>'+title+'</strong>'+text);

		$('.hex').not($(this)).hide();
		$('#hex').show();

	});

	$('.image-map-hex').on('click',function(e) {

		e.preventDefault();

		console.log($(this).attr('href'));

		let href = $(this).attr('href');
		let title = $(this).data('title');
		let text = $(this).data('text');
		$('.honeycomb-image-text').html('<strong>'+title+'</strong>'+text);

		$(href).parent().addClass('is-showing-text');

		

		// $('.hex').not($(this)).hide();
		// $('#hex').show();

	});

	$('.honeycomb').on('click', '.honeycomb-image-container.is-showing-text', function() {
		$(this).removeClass('is-showing-text');
	});

}